export default __webpack_public_path__ + "static/media/veined.8a420ac8.png";